const PREFIX = "pl-bill-banner-item";

export const PL_BILL_BANNER_ITEM_TEST_IDS = {
    CONTAINER: `${PREFIX}-container`,
};
